/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { InfoItem } from '@molecules';
import { pluralize } from '@utils';
import { useMedia, useArticle } from '@api/hooks';
import { getImage } from '@utils/media';

const Item = ({ module, errors }) => {
  const firstArticleId = module.content.articleIds?.[0] || {};
  const { article: firstArticle } = useArticle(firstArticleId);
  const { media } = useMedia(getImage(firstArticle, 'featureImage'));

  return (
    <InfoItem.WithError
      error={errors}
      size="large"
      image={media.src}
      description={pluralize(module.content.articleIds.length, 'article')}
    >
      Articles
    </InfoItem.WithError>
  );
};

export default Item;
